import { combineReducers } from 'redux'
import { authReducer } from './authReducer'
import { mainReducer } from './mainReducer'
import { popupReducer } from './popupReducer'

export const rootReducer = combineReducers({
    auth: authReducer,
    popup: popupReducer,
    main: mainReducer,
})

export type TReducer = ReturnType<typeof rootReducer>
